"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Svg = _interopRequireDefault(require("./Svg"));
var Presets = _interopRequireWildcard(require("./presets"));
const Skeleton = ({
  preset,
  ...props
}) => {
  const Component = preset ? Presets[preset] : _Svg.default;
  return /*#__PURE__*/React.createElement(Component, props);
};
var _default = exports.default = Skeleton;